import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { buttonReset } from '../../styled/buttons';
import { breakpoint } from '../../theme/breakpoint';

const iconSmall = '12px';
const iconLarge = '18px';

// This offset is a quick hack to prevent the icon touching the focus highlight
const offsetOn = `
  margin-right: -0.5em;
  padding-right: 0.5em;
`;
const offsetOff = `
  margin-right: 0em;
  padding-right: 0em;
`;

export const SubNavButton = styled.button`
  ${buttonReset};
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;

  // styling for mobile topics link
  span {
    font-size: ${({ theme }) => `${theme.fontsize.small}`};
    font-weight: ${({ theme }) => `${theme.fontWeight.bold}`};
    border-left: 1px solid ${({ theme }) => theme.palette.border};
    padding: ${({ theme }) => `0 ${theme.spacing.tiny}`};
    color: ${({ theme }) => theme.palette.link};
  }

  svg {
    ${({ open }) => open && `transform: rotate(180deg);`};
  }

  min-width: 2em;
  ${offsetOn};

  ${breakpoint.desktop`
    ${offsetOff};

    display: flex;
    width: 50px;
    padding: ${({ theme }) => `${theme.spacing.standard} 0`};
  `}
`;

export const ArrowSVG = styled(SVG)`
  width: ${iconLarge};
  height: ${iconLarge};
  display: block;
  fill: ${({ theme }) => theme.palette.standardText};
  cursor: pointer;
  pointer-events: none;

  ${({ $primaryNav }) =>
    $primaryNav &&
    /* mobile drawer primary nav button is smaller to accommodate 'topics' label */
    `
      width: ${iconSmall};
      height: ${iconSmall};
  `};
`;
